<script setup lang="ts">
import { storeToRefs } from 'pinia';
import LoyaltyHubSheet from './Sheet.vue';
import { useLoyaltyHubStore } from '@/stores/loyalty-hub';

// A Loja de Itens (VIP) aberta DENTRO de um modal por cima do hub Club
// Fidelidade — em vez de fechar o hub e navegar pra /vip/store. A ROTA CONTINUA
// existindo e igual: aqui reaproveitamos a mesma `<VipStoreV2 />`, em modo
// embutido (`sync-query="false"`), que é o que a impede de escrever `?tab=`/
// limpar `?open=` e de assinar o title da aba — a URL por baixo é de outra rota.
//
// Sem `title` no casco: a StoreV2 já traz o BaseScreenHeader dela ("Loja", com
// atualizar e histórico), então um título nosso duplicaria a linha.
//
// Estado só em memória (nada na URL), igual roletinha e cashback.
const store = useLoyaltyHubStore();
const { isStoreOpen } = storeToRefs(store);

// z-9995/9996/9997 (compra / termos / resultado): por cima do sheet (9994) e
// abaixo da roletinha (9999). Sem isto as janelas dela — 50/60/999 na rota —
// abririam ATRÁS do painel.
const MODAL_Z_INDEX = 9995;

// Monta só depois do slide-up: a loja é pesada (Swiper + itens do Smartico) e
// montar durante a animação faz a subida engasgar. Mesma estratégia do hub.
const mounted = ref(false);

function close() {
  store.closeStore();
}
</script>

<template>
  <LoyaltyHubSheet
    desktop-max-width="1000px"
    :open="isStoreOpen"
    @close="close"
    @closed="mounted = false"
    @opened="mounted = true"
  >
    <!-- Wrapper meu, e NÃO `class` direto na `<VipStoreV2>`: raiz de fragmento
         (a lista + as janelas dela) não herda classe — ver o mesmo caso no
         RewardsSheet. -->
    <div
      v-if="mounted"
      class="lhst-store"
    >
      <VipStoreV2
        :modal-z-index="MODAL_Z_INDEX"
        :sync-query="false"
      />
    </div>

    <!-- Enquanto o painel sobe, o vão fica com o esqueleto da grade. -->
    <div
      v-else
      class="lhst-loading"
    >
      <div
        v-for="i in 6"
        :key="`lhst-skeleton-${i}`"
        class="lhst-skeleton"
      ></div>
    </div>
  </LoyaltyHubSheet>
</template>

<style scoped lang="scss">
// A loja se desenha pra ser a PÁGINA: largura máxima própria, recuos laterais e
// a folga de topo do header do site. Dentro do painel isso deixa a grade
// estreita e afundada, então soltamos a largura e zeramos as folgas de página.
// O alvo é por posição (`> *:first-child`) e não pela classe: `.storeV2` é CSS
// module, com hash em build.
.lhst-store {
  width: 100%;

  :deep(> *:first-child) {
    max-width: none !important;
    width: 100% !important;
    margin: 0 !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
    padding-top: 0 !important;
  }
}

.lhst-loading {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}

.lhst-skeleton {
  @apply w-full h-32 rounded-lg bg-texts/5 border border-solid border-texts/10;
}
</style>
